import React from 'react';
import styles from './CommunityGuidelines.module.css';
import CrossedPathsCommunityGuidelinesComponent from '../Components/CommunityGuidelines';
import Footer from '../../Desktop/Components/Footer';

const CommunityGuidelines = ({onNavigate}) => {
  return (
    <section className={styles.communityGuidelines}>
      <div className={styles.body}>
      <h2 className={styles.titleText}>A trust based community</h2>
      </div>
      <div className={styles.text}>

        <CrossedPathsCommunityGuidelinesComponent/>
      </div>
      <Footer  onNavigate={onNavigate}/>
    </section>
  );
};

export default CommunityGuidelines;
